var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5556C20.003 12.7288 19.7289 13.8861 19.2 14.9333C18.5728 16.1882 17.6086 17.2437 16.4155 17.9816C15.2223 18.7195 13.8473 19.1106 12.4444 19.1111C11.2712 19.1142 10.1139 18.8401 9.06666 18.3111L4 20L5.68889 14.9333C5.15994 13.8861 4.88583 12.7288 4.88889 11.5556C4.88943 10.1527 5.28054 8.77766 6.01841 7.58451C6.75629 6.39135 7.81178 5.42719 9.06666 4.80002C10.1139 4.27107 11.2712 3.99697 12.4444 4.00003H12.8889C14.7416 4.10224 16.4916 4.88426 17.8037 6.19634C19.1157 7.50843 19.8978 9.25837 20 11.1111V11.5556Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.60358C10.1881 9.06891 10.5593 8.61807 11.048 8.33089C11.5366 8.04371 12.1111 7.93873 12.6697 8.03455C13.2284 8.13037 13.7351 8.4208 14.1001 8.8544C14.4651 9.28801 14.6648 9.8368 14.664 10.4036C14.664 12.0036 12.264 12.8036 12.264 12.8036M12.328 16.0036H12.336",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSupport);
export default __webpack_public_path__ + "static/media/help-support.9b4cdc4e64f3da9587614a00f2d94f6a.svg";
export { ForwardRef as ReactComponent };